const PrivacyPolicy = () => {
  return (
    <div className="container my-5 px-[2%]">
      <h1 className="text-center text-3xl font-roboto-slab text-[#0976BC] mb-6">
        Politique de Confidentialité
      </h1>

      <div className="text-[#2F2F2F] text-sm space-y-6">
        <p><strong>Dernière mise à jour :</strong> 30 mai 2025</p>

        <p>
          Bienvenue sur le site{" "}
          <a className="text-blue-600" href="https://copa.transforme.cd">
            https://copa.transforme.cd
          </a>{" "}
          (ci-après « le Site »), exploité par COPA Transforme. La présente Politique de Confidentialité a pour objectif de vous informer de manière claire et transparente sur la manière dont vos données personnelles sont collectées, utilisées, stockées et protégées. 
        </p>

        <section>
          <h2 className="font-semibold text-lg">1. Définitions</h2>
          <ul className="list-disc ml-5">
            <li>
              <strong>Compte :</strong> un compte unique créé pour vous permettre d'accéder à notre Service.
            </li>
            <li>
              <strong>Données personnelles :</strong> toute information se rapportant à une personne physique identifiée ou identifiable.
            </li>
            <li>
              <strong>Données d’utilisation :</strong> données collectées automatiquement, telles que l'adresse IP, type de navigateur, pages visitées.
            </li>
            <li>
              <strong>Service :</strong> le site web https://copa.transforme.cd exploité par COPA Transforme.
            </li>
            <li>
              <strong>Vous :</strong> la personne utilisant le service ou représentant légal d'une entité qui l'utilise.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-lg">2. Responsable du traitement</h2>
          <p>
            <strong>COPA Transforme :</strong> L’Unité de Coordination du Projet d’Autonomisation des Femmes Entrepreneures et mise à niveau des PME pour la Transformation Economique et l’Emploi (UCP/TRANSFORME-RDC)<br />
            <strong>Adresse :</strong> 9-11, Croisement des avenues Kisangani et Lemarinel, 2ème étage, Immeuble SOFIDE (en face du Collège Boboto) | Code postal 01209 | Kinshasa - Gombe | RDC<br />
            <strong>Email :</strong>{" "}
            <a className="text-blue-600" href="mailto:support@copa.transforme.cd">
              support@copa.transforme.cd
            </a>
            <br />
            <strong>Téléphone :</strong>
            <ul className="list-disc ml-5">
              <li>Goma : +243 975 694 577</li>
              <li>Bukavu : +243 859 789 377</li>
              <li>Bunia : +243 993 672 342</li>
              <li>Mbuji-Mayi : +243 856 801 297</li>
              <li>Kinshasa : +243 810 054 009 / +243 840 175 185</li>
              <li>Matadi : +243 833 591 149</li>
              <li>Kasangulu, Kisantu, Mbanza-Ngungu : +243 857 796 560</li>
              <li>Kimpese, Boma, Muanda : +243 857 796 560</li>
              <li>Kananga : +243 837 507 408</li>
            </ul>
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg">3. Données personnelles collectées</h2>
          <ul className="list-disc ml-5">
            <li>
              <strong>Données d’identification :</strong> Nom, prénom, email, téléphone.
            </li>
            <li>
              <strong>Données de connexion :</strong> Adresse IP, navigateur, système d’exploitation.
            </li>
            <li>
              <strong>Données des formulaires :</strong> Toute donnée soumise via nos formulaires.
            </li>
            <li>
              <strong>Données de navigation :</strong> Pages consultées, durée de session, clics.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-lg">4. Finalités du traitement</h2>
          <p>
            Les données collectées sont utilisées pour :
          </p>
          <ul className="list-disc ml-5">
            <li>Répondre à vos demandes</li>
            <li>Fournir nos services</li>
            <li>Gérer les inscriptions</li>
            <li>Améliorer le site</li>
            <li>Assurer la sécurité</li>
            <li>Respecter les obligations légales</li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-lg">5. Bases légales du traitement</h2>
          <p>
            Le traitement de vos données repose sur :
          </p>
          <ul className="list-disc ml-5">
            <li>Votre consentement explicite</li>
            <li>Notre intérêt légitime</li>
            <li>Nos obligations légales</li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-lg">6. Durée de conservation</h2>
          <ul className="list-disc ml-5">
            <li>
              <strong>Données de contact :</strong> Conservées pendant 3 ans.
            </li>
            <li>
              <strong>Données de navigation :</strong> Conservées pendant 13 mois.
            </li>
            <li>
              <strong>Obligations légales :</strong> Conservées selon les textes en vigueur.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-lg">7. Partage des données</h2>
          <p>
            Vos données peuvent être partagées avec :
          </p>
          <ul className="list-disc ml-5">
            <li>Nos hébergeurs</li>
            <li>Nos prestataires techniques</li>
            <li>Les autorités légales, si requis</li>
          </ul>
          <p>
            Aucune donnée n’est vendue ou cédée à des fins commerciales.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg">8. Cookies</h2>
          <p>
            Nous utilisons des cookies pour :
          </p>
          <ul className="list-disc ml-5">
            <li>Faciliter la navigation</li>
            <li>Mesurer l’audience</li>
            <li>Améliorer nos services</li>
          </ul>
          <p>
            Vous pouvez gérer les cookies via le bandeau affiché lors de votre première visite.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg">9. Vos droits</h2>
          <p>
            Vous disposez des droits suivants sur vos données :
          </p>
          <ul className="list-disc ml-5">
            <li>Accès</li>
            <li>Rectification</li>
            <li>Effacement</li>
            <li>Limitation</li>
            <li>Opposition</li>
            <li>Portabilité</li>
            <li>Retrait de consentement</li>
          </ul>
          <p>
            Pour exercer ces droits, contactez-nous à :{" "}
            <a className="text-blue-600" href="mailto:support@copa.transforme.cd">
              support@copa.transforme.cd
            </a>
            . Réponse dans un délai d’un mois.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg">10. Sécurité des données</h2>
          <p>
            Nous mettons en place des mesures techniques et organisationnelles pour protéger vos données, telles que :
          </p>
          <ul className="list-disc ml-5">
            <li>Chiffrement</li>
            <li>Accès restreint</li>
            <li>Pare-feu</li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-lg">11. Suppression de vos données personnelles</h2>
          <p>
            Vous pouvez demander la suppression de vos données à tout moment. Certaines informations peuvent être conservées pour des raisons légales.
          </p>
          <p>
            Vous pouvez mettre à jour, modifier ou supprimer vos données personnelles en vous connectant à votre compte (si applicable) et en accédant aux paramètres du compte. Vous pouvez également nous contacter à{" "}
            <a className="text-blue-600" href="mailto:support@copa.transforme.cd">
              support@copa.transforme.cd
            </a>{" "}
            pour demander l’accès, la correction ou la suppression de vos données.
          </p>
          <p>
            Notez que certaines données peuvent être conservées si requis par la loi ou justifié par un intérêt légitime.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg">12. Confidentialité des enfants</h2>
          <p>
            Notre Service ne cible pas les enfants de moins de 13 ans. Nous ne collectons pas intentionnellement de données auprès de mineurs.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg">13. Liens vers d'autres sites</h2>
          <p>
            Notre Service peut contenir des liens vers des sites tiers. Nous ne sommes pas responsables des politiques de confidentialité de ces sites.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg">14. Transferts internationaux de données</h2>
          <p>
            Vos données peuvent être transférées hors de votre juridiction. Des garanties appropriées sont mises en place pour protéger vos données.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg">15. Modifications</h2>
          <p>
            Nous pouvons modifier cette politique à tout moment. La dernière mise à jour est indiquée en haut de cette page.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;